import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import type { LeadClassification } from "../api/leads";

/**
 * Coloured lead "temperature" chip: warm→cold hue
 * (TOPLO red / MLAKO amber / HLADNO blue) with a translucent fill and the
 * localized label. Colour is never the only signal — the label always names
 * the classification. Mirrors the LeadStageBadge idiom.
 */
const COLOR: Record<LeadClassification, string> = {
  TOPLO: "var(--err)",
  MLAKO: "var(--warn)",
  HLADNO: "var(--info)",
};

export function LeadClassificationChip({ classification }: { classification: LeadClassification }) {
  const { t } = useTranslation();
  const color = COLOR[classification];
  const style: CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "3px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    color: "var(--ink)",
    background: `color-mix(in srgb, ${color} 14%, var(--surface))`,
    border: `1px solid ${color}`,
    whiteSpace: "nowrap",
  };
  return (
    <span style={style}>
      <span aria-hidden style={{ width: 8, height: 8, borderRadius: "50%", background: color, flex: "none" }} />
      {t(`leads.classification.${classification}`, classification)}
    </span>
  );
}
